module.exports = __webpack_public_path__ + "img/bg_course_offline@2x.5fbaa1e1.png";